import eventListener from "Packages/Carbon/Carbon.FileLoader/Resources/Private/Assets/EventListener";

eventListener("zammad:init", () => {
    Alpine.data("zammad", function (baseUrl: string, title: string, open: boolean) {
        return {
            open: !!open,
            name: "",
            email: "",
            body: "",
            agreement: false,
            fingerprint: "",
            token: "",
            ticketnumber: "",
            loading: false,
            failed: false,
            online: this.$persist(false).using(sessionStorage).as("zammad-online"),
            error: {
                name: false,
                email: false,
                body: false,
                agreement: false,
            },
            authentificate() {
                if (!this.open || (this.token && this.fingerprint)) {
                    return;
                }
                this.fingerprint = createFingerprint();
                fetch(`https://${baseUrl}/api/v1/form_config`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        fingerprint: this.fingerprint,
                    }),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not ok");
                        }
                        return response.json();
                    })
                    .then((data) => {
                        this.token = data.token;
                    })
                    .catch((error) => {
                        this.setFailed(error);
                    });
            },
            init() {
                if (!baseUrl) {
                    this.online = false;
                    return;
                }
                if (this.online) {
                    this.authentificate();
                } else {
                    isSiteOnline(`https://${baseUrl}`, (online) => {
                        this.online = online;
                        if (online) {
                            this.authentificate();
                        } else {
                            console.warn(`Helpdesk (${baseUrl}) is not reachable`);
                        }
                    });
                }

                this.$watch("open", () => {
                    this.authentificate();
                });
            },
            form: {
                "x-id"() {
                    return ["name", "email", "body", "files"];
                },
                "x-show"() {
                    return !this.ticketnumber;
                },
                "x-on:submit.prevent"(event) {
                    this.failed = false;
                    let hasError = false;
                    if (!this.name) {
                        hasError = true;
                        this.error.name = true;
                    }
                    if (!this.body) {
                        hasError = true;
                        this.error.body = true;
                    }
                    if (!this.email) {
                        hasError = true;
                        this.error.email = true;
                    }
                    if (!this.agreement) {
                        hasError = true;
                        this.error.agreement = true;
                    }
                    if (hasError) {
                        return;
                    }

                    const body = new FormData(event.target);
                    body.append("fingerprint", this.fingerprint);
                    body.append("agreement", "on");
                    body.append("token", this.token);
                    body.append("title", title.replaceAll("%s", window.location.hostname));

                    fetch(`https://${baseUrl}/api/v1/form_submit`, {
                        method: "POST",
                        body,
                    })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error("Network response was not ok");
                            }
                            return response.json();
                        })
                        .then((data) => {
                            this.loading = false;
                            this.ticketnumber = data?.ticket?.number;
                        })
                        .catch((error) => {
                            this.setFailed(error);
                        });
                },
            },
            setFailed(error) {
                console.error(error);
                this.loading = false;
                this.failed = true;
            },
        };
    });
});

function createFingerprint() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const txt = "https://zammad.com";
    ctx.textBaseline = "top";
    ctx.font = "12px 'Arial'";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(100, 200, 0, 0.7)";
    ctx.fillText(txt, 4, 17);
    return canvas.toDataURL();
}

function isSiteOnline(url, callback) {
    // try to load favicon
    const timer = setTimeout(() => {
        // timeout after 5 seconds
        callback(false);
    }, 5000);

    const img = document.createElement("img");
    img.onload = () => {
        clearTimeout(timer);
        callback(true);
    };

    img.onerror = () => {
        clearTimeout(timer);
        callback(false);
    };

    img.src = url + "/favicon.ico";
}
